import type { UserFunction } from '../../../../shared/types';
import TextRenderer from './TextRenderer';

const FunctionRenderer = (value: number, { userFunctions }: { userFunctions: Record<number, UserFunction> }) =>
  TextRenderer(userFunctions[value]?.name);

export default FunctionRenderer;
